import { ILogicOptions } from "../libs/logicSelect";

export type LogicDataType = {
    id: string;
    type: string;
    label: string;
    layoutWeight: { x: number; y: number };
};

export const orderFieldsForLogic = (fields: LogicDataType[]): ILogicOptions => {
    fields.sort((a, b) => {
        return a.layoutWeight.x - b.layoutWeight.x;
    });
    fields.sort((a, b) => {
        return a.layoutWeight.y - b.layoutWeight.y;
    });

    return fields.reduce<ILogicOptions>((accumulator: ILogicOptions, current) => {
        return { ...accumulator, [current.id]: { label: current.label, type: current.type } };
    }, {});
};
